import { render, staticRenderFns } from "./CardPreguntaFinal.vue?vue&type=template&id=1a83bb74&"
import script from "./CardPreguntaFinal.vue?vue&type=script&lang=js&"
export * from "./CardPreguntaFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports